var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
/**
 * @hidden
 */
var FocusableUponSelection = /** @class */ (function (_super) {
    __extends(FocusableUponSelection, _super);
    function FocusableUponSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    FocusableUponSelection.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.selected && this.props.selected) {
            this.elementToFocus.focus();
        }
    };
    return FocusableUponSelection;
}(React.Component));
export { FocusableUponSelection };
//# sourceMappingURL=FocusableUponSelection.js.map